<template>
    <div class="modal" :class="{'is-active':isActiveIpadDeviceRequestModal}">
        <div @click="CloseModal()" class="modal-background"></div>
        <div class="modal-content animate__animated animate__zoomIn animate__faster" style="width: 70%;height: 100%">
            <div class="notification is-white" style="width: 100%; height: 100%;">
                <div class="box">
                    <div class="level">
                        <div class="level-left">
                            <h2>{{(RequestTypes.find(x=>x.value==ActiveReqType)).text}} File Request History Modal</h2>
                        </div>

                        <div class="level-right">
                            <p>Start Date</p>
                            <div class="field has-addons" style="padding-right: 15%;">
                                <datepicker :config="{ wrap: true ,static:true}" v-model="SearchDate1">
                                    <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                                </datepicker>
                            </div>
                        </div>

                        <div class="level-right">
                            <p>End Date</p>
                            <div class="field has-addons" style="padding-right: 15%;">
                                <datepicker :config="{ wrap: true }" v-model="SearchDate2"
                                            @input="CheckEndDate(SearchDate1,SearchDate2)">
                                    <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                                </datepicker>
                            </div>
                        </div>
                        <div>
                            <a class="button  is-success is-fullwidth" @click="GetRequestList()">
                                                                    <span class="icon is-small">
                                                                            <font-awesome-icon icon="sync-alt"/>
                                                                    </span>
                            </a>
                        </div>

                        <div class="level-right">

                            <div class="icon-full-screen">
                                <img src="../../assets/images/close.svg"
                                     class="image is-24x24"
                                     title="Close"
                                     @click="CloseModal()"/>
                            </div>
                        </div>
                    </div>
                    <div class="level">
                        <div class="level-left">
                            <th>Device UUID:</th>
                            <td class="labelpad">{{ActiveDevice.devicE_UUID}}</td>

                            <th>Os Version:</th>
                            <td class="labelpad">{{ActiveDevice.osVersion}}</td>

                            <th>Tlc last Logged In :</th>
                            <td class="labelpad"> {{ActiveDevice.tlcLastLoggedIn}}</td>

                            <th>Last Login Time :</th>
                            <td class="labelpad">{{ActiveDevice.lastLoginTime | longFormatFromDT}}</td>

                            <th>Last Heart Beat DT:</th>
                            <td class="labelpad">{{ActiveDevice.lastHeartBeat_DT | longFormatFromDT}}</td>
                        </div>
                    </div>
                    <div class="request-table">
                        <table class="table is-narrow is-fullwidth is-narrow is-striped is-bordered animate__animated animate__faster animate__slideInUp">
                            <thead class="sticky-head">
                            <tr>
                                <th>FKEY</th>
                                <th>ACT</th>
                                <th>Who Request Last</th>
                                <th>Last Received File Name</th>
                                <th>Last Requested DT</th>
                                <th>Last Checked DT</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="device in this.ReqListOdReqTypeAndDevice" :key="device.id">
                                <td>{{device.fkey}}</td>
                                <td>
                                    <div v-if="device.rstat==false && device.reqLVT==0">
                                        <button class="button is-danger" @click="MakeOneRequest(device.fkey)">
                                            <span>No Req</span>
                                        </button>
                                    </div>
                                    <div v-if="device.rstat==false && device.reqLVT!=0">
                                        <button class="button is-info" @click="MakeOneRequest(device.fkey)">
                                            <span>Request</span>
                                        </button>
                                    </div>
                                    <div v-else-if="device.rstat==true && device.reqLVT!=device.reqLVC">
                                        <button class="button is-warning">
                                            <span>Pending</span>
                                        </button>
                                    </div>
                                    <div v-else-if="device.rstat==true && device.reqLVT==device.reqLVC">
                                        <button class="button is-success">
                                            <span>Done</span>
                                        </button>
                                    </div>
                                </td>
                                <td>{{device.whoRequestedLast}}</td>
                                <td v-if="ActiveReqType=='O'||ActiveReqType=='I'"><a
                                        :href="ActiveZipDownload + ActiveIpadDevice_UUID + '/' + ActiveReqType + '/'+device.fkey + '/'+device.lastReceivedFileName">{{device.lastReceivedFileName}}</a>
                                </td>
                                <td v-else><a
                                        :href="ActiveZipDownload + ActiveIpadDevice_UUID + '/' + ActiveReqType + '/' + 'X' + '/'+device.lastReceivedFileName">{{device.lastReceivedFileName}}</a>
                                </td>

                                <td>{{device.reqLVT}}</td>
                                <td>{{device.resLVC}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import Datepicker from "vue-bulma-datepicker";
    import http, {createUrl} from "../../http";

    export default {
        name: "IpadDevicesRequestModal",
        props: ['isActiveIpadDeviceRequestModal', 'ActiveIpadDevice_UUID', 'ActiveReqType', 'ActiveDevice'],

        data() {
            return {
                modalsize: {
                    width: "70%",
                    height: "85%"
                },
                SearchDate1: new Date().toISOString().slice(0, 10),
                SearchDate2: new Date().toISOString().slice(0, 10),
                RequestListModel: {
                    device_uuid: '',
                    reqType: '',
                    date1: '',
                    date2: '',
                    whoRequestedLast: '',
                    fkeyforzip: '',
                },
                RequestTypes: [
                    {text: 'OCC', value: 'O'},
                    {text: 'INPUTS', value: 'I'},
                    {text: 'LOG', value: 'L'},
                    {text: 'DIRECTORY', value: 'D'},
                    {text: 'MAP', value: 'M'}
                ],
                ActiveZipDownload: createUrl('/EFBDevice/GetZipFile/'),
                currentDate: ""
            }
        },

        async created() {

            this.currentDate = new Date().toISOString().slice(0, 10);
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.SearchDate2 = tomorrow.toISOString().slice(0, 10);

            this.clear_ReqListOdReqTypeAndDevice();

        },

        methods: {

            ...mapActions("efb", ["Getinspectorviewlist", "GetdeviceslistByuuid", "GetheartbeatsignalsByuuid", "GetSummaryListOfDevice", "GetReqListOdReqTypeAndDevice", "GetIpadRequestFile_MakeOneRequest", "clear_ReqListOdReqTypeAndDevice"]),

            fullscreenModal() {
                this.modalsize.width = '100%',
                    this.modalsize.height = '100%'
            },

            defaultScreenModal() {
                this.modalsize.width = '70%',
                    this.modalsize.height = '60%'
            },

            CloseModal() {
                this.clear_ReqListOdReqTypeAndDevice();
                this.$emit('closeIpadDeviceRequestModal');
            },

            DownloadRequestedFile(FileName) {
                //let Url = this.activeZipDownload + this.ActiveIpadDevice_UUID + '/' + this.ActiveReqType + '/' + FileName;

                const ReqList = http.instance.get("/EFBDevice/GetZipFile",
                    {
                        params: {
                            Device_UUID: this.ActiveIpadDevice_UUID,
                            filename: FileName,
                            ReqType: this.ActiveReqType,
                        }
                    });
                return ReqList.data;

                //EfbService.GetZipFile(Url);

                // this.http.get({
                //     method: 'get',
                //     url: this.activeZipDownload + this.ActiveIpadDevice_UUID + '/' + this.ActiveReqType + '/' + FileName,
                //     responseType: 'arraybuffer'
                // })
                //     .then(response => {
                //         //this.forceFileDownload(response)
                //         this.$notify({title: "Success", text: ""+response, type: "success"});
                //     })
                //     .catch((e) => this.$notify({title: "Error", text: ""+e.message, type: "error"}))

            },

            async GetRequestList() {


                if (this.SearchDate1 == null || this.SearchDate2 == null) {
                    //this.$notify({title: "Warning", text: " Date areas couldn't be null. ", type: "warning"});
                    return;
                }

                this.RequestListModel.device_uuid = this.ActiveIpadDevice_UUID;
                this.RequestListModel.reqType = this.ActiveReqType;

                this.RequestListModel.date1 = this.SearchDate1;
                this.RequestListModel.date2 = this.SearchDate2;

                await this.GetReqListOdReqTypeAndDevice(this.RequestListModel);
            },

            async MakeOneRequest(fkey) {
                if (this.SearchDate1 == null || this.SearchDate2 == null) {
                    //this.$notify({title: "Warning", text: " Date areas couldn't be null. ", type: "warning"});
                    return;
                }

                this.RequestListModel.device_uuid = this.ActiveIpadDevice_UUID;
                this.RequestListModel.reqType = this.ActiveReqType;
                this.RequestListModel.date1 = this.SearchDate1;
                this.RequestListModel.date2 = this.SearchDate2;
                this.RequestListModel.whoRequestedLast = "Evren Başer";
                this.RequestListModel.fkeyforzip = fkey;

                const ReqMessage = await http.instance.get("/EFBDevice/GetIpadRequestFile_MakeOneRequest", {
                    params: {
                        DEVICE_UUID: this.ActiveIpadDevice_UUID,
                        REQTYPE: this.ActiveReqType,
                        FKeyForzip: this.RequestListModel.fkeyforzip,
                        // WhoRequestedLast : this.RequestListModel.whoRequestedLast,
                        Date1: this.SearchDate1,
                        Date2: this.SearchDate2
                    }
                });

                let message = ReqMessage.data;
                console.log(message);
                //this.$notify({title: "Warning", text: message, type: "warning"});

                await this.GetRequestList();
            },

            async CheckEndDate(Date1, Date2) {

                if (Date1 < Date2) {
                    this.SearchDate1 = Date1;
                    this.SearchDate2 = Date2;
                } else if (Date1 == Date2) {
                    this.SearchDate1 = Date1;
                    this.SearchDate2 = Date2;
                    //this.$notify({title: "Warning", text: "Start date and End date is same", type: "warning"});
                } else if (Date1 > Date2) {
                    this.SearchDate1 = Date1;
                    this.SearchDate2 = null;
                    //this.$notify({title: "Warning", text: "End date is unvalid.", type: "warning"});
                }
            },

        },

        mounted() {
            // setInterval(() =>
            // {
            //     try
            //     {
            //         if (this.SearchDate1 != null && this.SearchDate2 != null && this.isActiveIpadDeviceRequestModal== true)
            //         {
            //             this.GetRequestList();
            //         }
            //
            //     }
            //     catch (e) {
            //         this.$notify({title: "Warning", text: +"couldn't get RequesList "+ e.message, type: "warning"});
            //     }
            // },
            //     25000);

            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) { //ESC
                    this.clear_ReqListOdReqTypeAndDevice();
                    this.$emit('closeIpadDeviceRequestModal');
                }
            })


        },

        components: {
            Datepicker,
        },


        computed: {

            ...mapState("efb", ["inpectorviewlist", "deviceslistByuuid", "heartbeatsignalsByuuid", "DeviceSummaryList", "ReqListOdReqTypeAndDevice"]),

        },


    }
</script>

<style scoped>

    .labelpad {
        padding-right: 5px;
    }

    .icon-full-screen {
        margin-left: 10px;
    }

    .request-table {
        overflow-y: scroll;
        height: 690px;
    }

    .sticky-head th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: white;

        outline: 1px solid #e9ecef;
        outline-offset: -1px;
        margin-top: 10px;

    }

    .icon-full-screen:hover {
        cursor: pointer;
        box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.1);
        transform: scale(1.02);
        background-color: whitesmoke;
    }
</style>

